// removed by extract-text-webpack-plugin
module.exports = {"companySearchBox":"companySearchForm_companySearchBox_2AqzD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/company/companySearchForm.scss
// module id = 1558
// module chunks = 0